module.exports = __webpack_public_path__ + "img/Brainstorming_session_Flatline.02b3c294.svg";